"use client";

import { useEffect } from "react";
import Link from "next/link";
import * as Sentry from "@sentry/nextjs";

// Not: bu dosya layout dışında render olur; globals.css yüklenmez.
// Bu yüzden tema renkleri inline style ile verilir.
const PRIMARY = "#6d28d9";
const PRIMARY_DARK = "#4c1d95";
const INK = "#231a2e";
const MUTED = "#6b7280";
const BG_LIGHT = "#faf5ff";
const BG_LINE = "#ede9fe";

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    try {
      Sentry.captureException(error);
    } catch {
      /* raporlama hatası sayfayı engellemez */
    }
  }, [error]);
  return (
    <html lang="tr">
      <body style={{ margin: 0, background: "#fff", fontFamily: "Arial, Helvetica, sans-serif" }}>
        <div style={{ margin: "0 auto", maxWidth: 480, minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 16, textAlign: "center" }}>
          <span style={{ display: "flex", width: 64, height: 64, alignItems: "center", justifyContent: "center", borderRadius: 20, background: BG_LIGHT, color: PRIMARY, fontSize: 28, fontWeight: 700, outline: `1px solid ${BG_LINE}` }} aria-hidden="true">
            !
          </span>
          <h1 style={{ margin: "16px 0 0", fontSize: 24, fontWeight: 400, color: INK }}>Bir şeyler ters gitti</h1>
          <p style={{ margin: "8px 0 0", fontSize: 14, color: MUTED }}>
            Beklenmeyen bir hata oluştu. {error.digest ? `Referans: ${error.digest}` : "Tekrar deneyin."}
          </p>
          <button
            onClick={reset}
            style={{ marginTop: 24, minHeight: 44, border: 0, borderRadius: 999, background: PRIMARY, color: "#fff", padding: "10px 24px", fontSize: 14, fontWeight: 500, cursor: "pointer" }}
            onMouseOver={(e) => (e.currentTarget.style.background = PRIMARY_DARK)}
            onMouseOut={(e) => (e.currentTarget.style.background = PRIMARY)}
          >
            Tekrar Dene
          </button>
          <Link href="/" style={{ marginTop: 12, fontSize: 14, color: PRIMARY }}>
            Ana sayfaya dön
          </Link>
        </div>
      </body>
    </html>
  );
}
